import { CANCEL_RULE } from '../lib/status';
import type { Course } from '../types/api';

function periods(course: Course): string {
  if (course.period_names?.length) return course.period_names.join('、');
  return `${course.period_ids.length} 节`;
}

export function CourseTime(props: { course: Course; compact?: boolean }) {
  const c = props.course;
  const openLine = `开课时间：${c.course_date} ${periods(c)}`;
  const signupLine = `报名开始：${c.signup_open_at}；报名截止：${c.signup_close_at}`;
  if (props.compact) {
    return (
      <div className="meta">
        <div>开课：{c.course_date} {periods(c)}</div>
        <div>报名截止：{c.signup_close_at}</div>
      </div>
    );
  }
  return (
    <div className="stack" style={{ gap: 4 }}>
      <div>{openLine}</div>
      <div>{signupLine}</div>
      <div className="meta">{CANCEL_RULE}</div>
    </div>
  );
}
